import React from "react";
import SpotIllustrationHybrid from "./SpotIllustrationHybrid";
import type { TypeSpotIllustrationProps } from "./SpotIllustrationTypes";

/**
 * SpotIllustration component. Renders the Tailwind (CSS-class) implementation via
 * the Hybrid. SpotIllustration exposes no styled-system props, so the Hybrid is a
 * thin passthrough to the Tailwind path.
 */
const SpotIllustration = (props: TypeSpotIllustrationProps) => (
  <SpotIllustrationHybrid {...props} />
);

SpotIllustration.displayName = "SpotIllustration";

export default SpotIllustration;
